import { connect } from 'react-redux';
import Footer from './Footer';
import { updateNewSearchTextActionCreator } from '../../redux/products-reducer';


let mapStateToProps = (state) => {
  return {
    shopName: state.aboutPage.aboutData.shopName,
  }
}

let mapDispatchToProps = (dispatch) => {
  return {
    updateNewSearchText: (text) => {
      dispatch(updateNewSearchTextActionCreator(text))
    }, 
    // addPost: () => {
    //   dispatch(addPostActionCreator())
    // }
  }
}

const FooterContainer = connect(mapStateToProps, mapDispatchToProps)(Footer);

export default FooterContainer;